<template>
    <div>
        <card>
            <template slot="header">
                Templates
            </template>
            <div class="row">
                <div class="col-12 d-flex justify-content-end">
                    <div
                        v-if="
                            user.admin ||
                                (event.adminRoles &&
                                    event.adminRoles[user._id] &&
                                    event.adminRoles[user._id]
                                        .editTemplates)
                        "
                    >
                        <el-button
                            @click="templateFormOpen = true"
                            type="primary"
                            class="btn btn-primary"
                        >
                            New
                        </el-button>
                    </div>
                </div>
            </div>
            <el-table :data="templates">
                <el-table-column label="Name" prop="name" min-width="200px">
                </el-table-column>
                <el-table-column label="Actions" min-width="300px">
                    <template slot-scope="props">
                        <el-tooltip content="Print" placement="top">
                            <el-button
                                @click="fetchPrintables(props.row)"
                                class="btn btn-primary mr-1"
                                title="print"
                            >
                                <fa :icon="['fas', 'print']" />
                            </el-button>
                        </el-tooltip>
                        <template
                            v-if="
                                user.admin ||
                                    (event.adminRoles &&
                                        event.adminRoles[user._id] &&
                                        event.adminRoles[user._id]
                                            .editTemplates)
                            "
                        >
                            <el-tooltip content="Edit" placement="top">
                                <el-button
                                    @click="edit(props.row._id)"
                                    class="btn"
                                    title="Edit"
                                >
                                    <fa :icon="['fas', 'pen']" />
                                </el-button>
                            </el-tooltip>
                        </template>
                        <el-tooltip
                            v-if="
                                user.admin ||
                                    (event.adminRoles &&
                                        event.adminRoles[user._id] &&
                                        event.adminRoles[user._id]
                                            .editTemplates)
                            "
                            content="Delete" placement="top">
                            <el-button
                                @click="remove(props.row._id)"
                                class="btn btn-danger ml-1"
                                title="Delete"
                            >
                                <fa :icon="['fas', 'trash']" />
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </card>

        <el-dialog
            width="70%"
            v-if="templateFormOpen"
            :visible.sync="templateFormOpen"
            :close-on-click-modal="false"
        >
            <TemplateForm
                :fieldsForFilter="fieldsForFilter"
                :templateId="templateId"
                @close="templateFormOpen = false"
            />
        </el-dialog>
        <el-dialog
            width="70%"
            v-if="printModalOpen"
            :visible.sync="printModalOpen"
            :close-on-click-modal="false"
        >
            <div v-if="loading" class="d-flex justify-content-center">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            </div>

            <div v-else>
                <el-table
                    :data="Object.values(allRegistrants)"
                    style="max-height:50vh; overflow: auto;"
                    @selection-change="toggleExludeList"
                >
                    <el-table-column
                        type="selection"
                        label="Select" 
                        align="center"
                        width="100%"
                    />
                    <el-table-column
                        label="Confirmation"
                        prop="confirmationNumber"
                    >
                        <template slot-scope="props">
                            <router-link
                                target="_blank"
                                :to="
                                    `/dashboard/${eventId}/attendees/${
                                        props.row._id
                                    }?tab=general_information`
                                "
                                >{{ props.row.confirmationNumber }}</router-link
                            >
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="Select" width="100%" align="center">
                        <template slot-scope="props">
                            <el-checkbox
                                :checked="true"
                                @change="
                                    val => toggleExludeList(props.row, val)
                                "
                            />
                        </template>
                    </el-table-column> -->
                    <el-table-column label="Name">
                        <template slot-scope="props">
                            {{ props.row.fields[1].value }}
                            {{ props.row.fields[2].value }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Email" prop="fields[3].value" />
                    <el-table-column label="Total" prop="total" />
                    <el-table-column label="Paid" prop="paid" />
                    <el-table-column label="Due">
                        <template slot-scope="props">
                            {{ props.row.total - props.row.paid }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Type" prop="type.name" />
                    <el-table-column label="Preview">
                        <template slot-scope="props">
                            <button
                                class="btn btn-primary"
                                @click="openPreviewDialog(props.row)"
                            >
                                preview
                            </button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <template slot="footer">
                <el-button
                    v-if="!loading"
                    class="mr-3"
                    type="primary"
                    @click="downloadPdfs"
                >
                    Download Pdf
                </el-button>
            </template>
        </el-dialog>
        <el-dialog
            v-if="previewDialog"
            :visible.sync="previewDialog"
            :close-on-click-modal="false"
        >
            <div v-if="previewLoading" class="d-flex justify-content-center">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            </div>
            <div v-else v-html="html" class="ql-editor"></div>
        </el-dialog>

        <!-- <div class="ql-editor" id="print-only" v-html="generatedHtml"></div> -->
    </div>
</template>

<script>
import { mapState } from "vuex";
import swal from "sweetalert2";
import http from "../../http";
import TemplateForm from "./TemplateForm.vue";
import qlEditorStyles from "./ql-editor.json";
import moment from "moment";

export default {
    data() {
        return {
            templateFormOpen: false,
            templateId: null,
            printModalOpen: false,
            selectedRegistrants: [],
            allRegistrants: [],
            html: "",
            generatedHtml: "",
            previewDialog: false,
            eventId: null,
            selectedTemplateForPrint: {},
            loading: false,
            previewLoading: false,
            fieldsForFilter: []
        };
    },
    components: { TemplateForm },
    computed: {
        ...mapState(["user", "event", "templates"])
    },
    watch: {
        templateFormOpen(nv) {
            if (!nv) this.templateId = null;
        }
    },
    methods: {
        async remove(id) {
            let { value: confirmed } = await swal({
                title: `Are you sure you want to delete the template?`,
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-default btn-fill"
            });
            if (!confirmed) {
                return;
            }

            try {
                const res = await http.delete(`/api/templates/${id}`);
                if (res.data.message) {
                    this.$notify(res.data.message);
                }
                await this.$store.dispatch("getAll", { path: "templates", query: `event=${this.eventId}` });
            } catch (error) {
                console.log(error);
                if (error.response.data.message) {
                    this.$notify(error.response.data.message);
                }
            }
        },
        edit(id) {
            this.templateId = id;
            this.templateFormOpen = true;
        },
        async fetchPrintables(data) {
            this.selectedTemplateForPrint = data;
            this.printModalOpen = true;
            this.loading = true;
            try {
                const res = await http.post("/api/templates/registrants", { templateId: data._id });
                this.allRegistrants = res.data.registrations;
                this.selectedRegistrants = this.allRegistrants;
                setTimeout(()=>{
                    document.querySelector('th.el-table-column--selection .el-checkbox input').click()
                }, 500)
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }
            this.loading = false;
        },
        async downloadPdfs() {
            for (let i = 0; i < this.selectedRegistrants.length; i++) {
                let reg = this.selectedRegistrants[i];
                this.generatedHtml += `
                <div class="ql-editor" style="page-break-after: always; height: fit-content;">
                    ${reg.html}    
                </div>
                `;
            }

            let printWindow = window.open("", "_blank");
            printWindow.document.open();
            printWindow.document.write(`
            <html>
                <head>
                    <title>Print</title>
                    <style>
                        ${qlEditorStyles}
                    </style>
                </head>
                <body></body>
            </html>
            `);
            printWindow.document.write(this.generatedHtml);
            printWindow.document.write("</body></html>");
            printWindow.document.close();
            setTimeout(() => {
                printWindow.print();
            }, 500);
            this.generatedHtml = "";
        },
        async openPreviewDialog(registration) {
            this.previewDialog = true;
            this.previewLoading = true;
            this.html = registration.html
            this.previewLoading = false;
        },
        async toggleExludeList(registrations) {
            this.selectedRegistrants = registrations
        },

        async generateEmailForRegistration(html, registration) {
            for (let i = 0; i < registration.fields.length; i++) {
                let field = registration.fields[i];

                let foundAllregistrants = html.search(
                    new RegExp(`allregistrants.${field.name}`, "g")
                );

                if (foundAllregistrants > 0) {
                    const values = await this.getAllFieldRelatedValues(
                        field.name,
                        registration
                    );
                    html = html.replace(
                        new RegExp(`allregistrants.${field.name}`, "g"),
                        values
                    );
                }

                if (field.type === "checkboxes") {
                    let text = "";

                    field.value.forEach(value => {
                        text +=
                            field.labels.split("\n")[
                                field.values.split("\n").indexOf(value)
                            ] + " ";
                    });

                    html = html.replace(new RegExp(field.name, "g"), text);
                } else if (field.type === "radio" || field.type === "list") {
                    html = html.replace(
                        new RegExp(field.name, "g"),
                        field.labels.split("\n")[
                            field.values.split("\n").indexOf(field.value)
                        ]
                    );
                } else {
                    html = html.replace(
                        new RegExp(field.name, "g"),
                        field.value
                    );
                }
            }

            // replace total & due fields
            html = html.replace(
                new RegExp("total_amt", "g"),
                registration.total.toFixed(2)
            );
            html = html.replace(
                new RegExp("due_amt", "g"),
                (registration.total - registration.paid).toFixed(2)
            );
            html = html.replace(
                new RegExp("registrant_id", "g"),
                registration._id
            );
            html = html.replace(
                new RegExp("confirmation_number", "g"),
                registration.confirmationNumber
            );
            html = html.replace(
                new RegExp("registrant_count", "g"),
                registration.regCount
            );
            html = html.replace(
                new RegExp("registrant_type", "g"),
                registration.type.name
            );
            html = html.replace(new RegExp("paid_amt", "g"), registration.paid);
            html = html.replace(
                new RegExp("registration_created_date", "g"),
                moment(registration.createdAt).format("DD MMM YYYY HH:mm")
            );

            if (registration.event && registration.event._id) {
                html = html.replace(
                    new RegExp("EVENTSCODED_REG_TOTAL_AMT", "g"),
                    registration.event.totalRegistrations
                );
                html = html.replace(
                    new RegExp("EVENTSCODED_REG_PAID_AMT", "g"),
                    registration.event.totalPaid
                );
            }

            html = html.replace(/\$|{|}/g, "");

            return html;
        },

        async getAllFieldRelatedValues(fieldName, registration) {
            let htmlStr = "";
            const allRegistrants = (await http.get(
                `/api/registrations/all-by-confirmation-number/${
                    registration.confirmationNumber
                }/${this.$route.params.eventId}`
            )).data.registrations;

            allRegistrants.sort((a, _) => {
                if (a.parent) {
                    return 1;
                }
                return -1;
            });

            for (let i = 0; i < allRegistrants.length; i++) {
                htmlStr += `<span>${await this.generateEmailForRegistration(
                    fieldName,
                    allRegistrants[i]
                )}</span>`;
            }

            htmlStr = `<span style="display: inline-flex; flex-direction: column; gap:10px;">${htmlStr}</span>`;

            return htmlStr;
        }
    },
    async mounted() {
        this.eventId = this.$route.params.eventId;
        await this.$store.dispatch("getAll", { path: "templates", query: `event=${this.eventId}` });
        this.fieldsForFilter = (await http.get(`/api/fields-for-filters/${this.$route.params.eventId}`)).data.fields;
    }
};
</script>
